import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { LeadService } from '../../lead/lead.service';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-promo-packages',
  templateUrl: './promo-packages.component.html',
  styleUrls: ['./promo-packages.component.css'],
  providers: [LeadService]
})
export class PromoPackagesComponent implements OnInit {

  constructor(
    private leadService: LeadService,
    private loaderService: LoaderService,
    private formBuilder: FormBuilder,
  ) { }


  per_page;
  total_page;
  current_page;
  headers_res;
  page_number;

  promoPackagesForm: any;

  errorMessage: string;
  erroralert = false;
  successalert = false;
  successMessage: string;
  today_date: any;
  ngOnInit() {

    this.today_date = (new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 10, 33, 30, 0)).toISOString().split('T')[0]
    document.getElementsByName("txtDate")[0].setAttribute('min', this.today_date);
    this.getPromoPackages(1, '', 'active');
    this.getStatusList();
    this.promoPackagesForm = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      promo_code: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      remarks: new FormControl(''),
      promo_value: new FormControl(''),
      promo_discount_percent: new FormControl(''),
      promo_threshold: new FormControl('', Validators.required),
      expiry_date: new FormControl('')
    });
    
  }



  errorMessageShow(msg) {
    this.erroralert = true;
    this.errorMessage = msg;
    setTimeout(function () {
      this.erroralert = false;
    }.bind(this), 10000);
  }
  successMessageShow(msg) {
    this.successalert = true;
    this.successMessage = msg;
    setTimeout(function () {
      this.successalert = false;
    }.bind(this), 10000);
  }

  statusList: any = [];
  getStatusList() {
    this.loaderService.display(true);
    this.leadService.fetchStatusList().subscribe(
      res => {
        this.loaderService.display(false);
        this.statusList = res;
        
      },
      err => {
        this.loaderService.display(false);
      }
    );
  }

  lead_priority_que_arr;
  getPromoPackages(currentPage, value: any, status) {
    this.page_number = currentPage;
    this.loaderService.display(true);
    this.leadService.getPromoPackages(currentPage, value, '', '').subscribe(
      res => {
        this.loaderService.display(false);
        this.headers_res = res.headers._headers;
        this.per_page = this.headers_res.get('x-per-page');
        this.total_page = this.headers_res.get('x-total');
        this.current_page = this.headers_res.get('x-page');

        res = res.json();
        
        this.lead_priority_que_arr = res.promo_packs;
      },
      err => {
        this.loaderService.display(false);
      }
    );
  }

  clearEditPromoId() {
    this.validPromo = '';
    this.edited_promo_code = null;
    this.image = null;
    this.imageUrl = null;
    this.promoPackagesForm.reset();
  }

  imageUrl: any;
  edited_promo_code: any;
  fetchPromoDetails(promoId) {
    this.validPromo = '';
    this.edited_promo_code = promoId;
    this.loaderService.display(true);
    this.leadService.fetchPromoCode(promoId).subscribe(
      res => {
        this.loaderService.display(false);
        
        this.promoPackagesForm.controls['name'].setValue(res.promo_pack.name);
        this.promoPackagesForm.controls['promo_code'].setValue(res.promo_pack.code);
        this.promoPackagesForm.controls['description'].setValue(res.promo_pack.description);
        this.promoPackagesForm.controls['remarks'].setValue(res.promo_pack.remarks);
        this.promoPackagesForm.controls['promo_value'].setValue(res.promo_pack.promo_value);
        this.promoPackagesForm.controls['promo_discount_percent'].setValue(res.promo_pack.promo_discount_percent);
        this.promoPackagesForm.controls['promo_threshold'].setValue(res.promo_pack.threshold);
        this.promoPackagesForm.controls['expiry_date'].setValue(res.promo_pack.expiry_date);
        this.imageUrl = res.promo_pack.promo_image
      },
      err => {
        this.loaderService.display(false);
        
      }
    );
  }

  activeUploadImage() {
    document.getElementById("uploadImage").click()
  }

  image: any;
  imageName: any;
  uploadImage(event) {
    
    this.image = event.target.files[0];
    // this.imageUrl = URL.createObjectURL(event.target.files[0]);
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.imageUrl = base64.result;
    };
    fileReader.readAsDataURL(event.target.files[0]);
  }

  validPromo;
  validPromoDiscount;
  onSubmit(value) {
    this.loaderService.display(true);
    if(value.promo_value || value.promo_discount_percent){
      if (value.promo_code.indexOf(" ") > -1) {
        this.validPromo = "Enter Valid Promo Code (Space not allowed)";
        this.loaderService.display(false);
      }
      else {
        this.leadService.createPromoCode(value, this.image).subscribe(
          res => {
            this.loaderService.display(false);
            this.promoPackagesForm.reset();
            this.image = null;
            this.validPromo = '';
            $('#promoCodeModal').modal('hide');
            this.successMessageShow('Promo Code Created Successfully!');
            this.getPromoPackages(1, '', 'active');
          },
          err => {
            this.loaderService.display(false);
            this.erroralert = true;
            this.errorMessageShow(JSON.parse(err['_body']).message);
            this.errorMessageShow(JSON.parse(err['_body']).message.code);
            this.errorMessageShow(JSON.parse(err['_body']).message.promo_discount_percent[0]);
            this.validPromo = JSON.parse(err['_body']).message.code
          }
        );
      }
    }else{
      this.erroralert = true;
      this.errorMessage = "Enter Promo Value Or Promo Discount Percent";
      this.loaderService.display(false);
    }
     
  }

  update(value) {
    this.loaderService.display(true);
    if(value.promo_value || value.promo_discount_percent){
      if (value.promo_code.indexOf(" ") > -1) {
        this.validPromo = "Enter Valid Promo Code (Space not allowed)";
        this.loaderService.display(false);
      }
      else {
        this.leadService.updatePromoCode(value, this.edited_promo_code, this.image).subscribe(
          res => {
            this.loaderService.display(false);
            this.promoPackagesForm.reset();
            this.image = null;
            this.validPromo = '';
            $('#promoCodeModal').modal('hide');
            this.successMessageShow('Promo Code Updated Successfully!');
            this.getPromoPackages(1, '', 'active');
          },
          err => {
            this.loaderService.display(false);
            this.erroralert = true;
            this.errorMessage = JSON.parse(err['_body']).promo_discount_percent[0];
            this.errorMessage = JSON.parse(err['_body']).base[0];
            this.errorMessageShow(JSON.parse(err['_body']).message);
            this.errorMessageShow(JSON.parse(err['_body']).expiry_date);
            this.validPromo = JSON.parse(err['_body']).message.code;
          }
        );
      }
    } else{
      this.erroralert = true;
      this.errorMessage = "Enter Promo Value Or Promo Discount Percent";
      this.loaderService.display(false);
    }


  
  }

  downloadPromoPackages() {
    this.loaderService.display(true);
    this.leadService.downloadPromoCodes().subscribe(
      res => {
        
        this.loaderService.display(false);
        this.successMessageShow('Promo Code Packages Downloaded Successfully!');
        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        var b64Data = res.excel_base_64;
        var blob = this.b64toBlob(b64Data, contentType, 512);
        var blobUrl = URL.createObjectURL(blob);
        // let blob = new Blob(['\ufeff' + data._body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let dwldLink = document.createElement("a");
        // let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", blobUrl);
        dwldLink.setAttribute("download", "promo-package-report.xlsx");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
      },
      err => {
        this.loaderService.display(false);
        this.erroralert = true;
        this.errorMessageShow(JSON.parse(err['_body']).message);
      }
    );
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  changeStatus(id, value) {
    this.loaderService.display(true);
    this.leadService.updatePromoCodeStatus(id, value).subscribe(
      res => {
        this.loaderService.display(false);
        this.successMessageShow('Status Change Successfully');
        this.getPromoPackages(1, '', 'active');
      },
      err => {
        this.loaderService.display(false);
        this.errorMessageShow(JSON.parse(err['_body']).message);
      }
    );
  }

  ngOnDestroy() {
    $(function () {
      $('.pop').remove();
    })
  }

  openpopup(event) {
    var thisobj = this;
    $(event.target).popover({
      trigger: 'hover'
    });


    $(function () {
      $('.pop').popover({
        trigger: 'hover'
      })
    })
  }

  searchPromo() {
    let search = $('#serachPromo').val();
    this.getPromoPackages(1, search, 'active');
  }

  getChangeStatus(value) {
    this.getPromoPackages(1, '', value);
  }
}


// WEBPACK FOOTER //
// ./src/app/platform/organisation/promo-packages/promo-packages.component.ts